import { getCustomStatisticViewFields, getViewCustomStatisticConfig } from '@lighthouse/shared'
import { useMemo } from 'react'

import { useCurrentCustomViewBlock } from './useCurrentCustomViewBlock'

export function useCustomViewStatisticExtraFields() {
    const customView = useCurrentCustomViewBlock()
    return useMemo(
        () => getCustomStatisticViewFields(getViewCustomStatisticConfig(customView?.config), customView?.config.pointer),
        [customView]
    )
}
